import { ConsentManagementConfigVersion, invalidateQuery } from "@/api";
import { makeRequest } from "@/util";

export type PublishConfigVersionRequest = {
  type: ConsentManagementConfigVersion["type"];
  incrementRevision?: boolean;
  publishDescription?: string;
};
type PublishConfigVersionResponse = {
  version: ConsentManagementConfigVersion;
};

export async function publishConfigVersion(
  payload: PublishConfigVersionRequest,
) {
  await makeRequest<PublishConfigVersionResponse>(
    "publish_consent_management_config_version",
    payload,
  );

  await invalidateQuery([
    "get_consent_management_config_versions",
    { type: payload.type },
  ]);
}
